import axios from "../config/axios";

export function apiQuickUpdateFactoryEvaluationFee(id, data) {
	return axios.put(`factory-evaluation-fees/${id}/quick-update`, data);
}
